import React, { useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { useParams } from "react-router";
import { OrganizationService } from "../_service/organization.service";
import leftIcon from "../_assets/images/left_icon.png";
import { Button } from "../_components/button.component";

import accountImg from "../_assets/images/account.png";
import { TextInput } from "../_components/text-input.component";
import Table from "../_components/table.component";
import { getAddOrgPageRoute } from "./create-org.page";
import { ActionModal } from "../_components/action-modal.component";
import Switch from "../_components/switch.component";
import { UserService } from "../_service/user.service";
import BulkUserSample from "./../_assets/sample_files/bulk_import_sample.csv";
import { ToastTypes, withToast } from "../contexts/toastr.context";
import AccountDetail from "../_components/account-details.component";
import UserManagement from "../_components/user-management.component";
import { setOrganization } from "./../_store/_actions/organization.actions";

export const ORGANIZATION_ROUTE = "/organization";
export const ORG_DETAILS_ROUTE = (orgId) => "/organization" + "?orgId=" + orgId;

export function getOrganizationRoute(orgId) {
  return "/organization" + "?orgId=" + orgId;
}

let userListGlobal = [];

function OrgDetailsPageComponent({ user, history, addToast, orgData }) {
  const [openTab, setOpenTab] = React.useState(1);
  const [showAddUser, setShowAddUser] = useState(false);
  const [showEditAccount, setShowEditAccount] = useState(false);
  const [showUserEdit, setShowUserEdit] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();

  const getOrganization = (token) => {
    OrganizationService.getOrganizationByToken(user)
      .then((resp) => {
        dispatch(setOrganization({ organization: resp }));
      })
      .catch((error) => {
        if (error && error.response && error.response.data.message) {
          addToast(error.response.data.message, "", ToastTypes.danger);
        }
      });
  };

  useEffect(() => {
    if (user.role === "orgAdmin") {
      if (location.state?.openTab) {
        setOpenTab(location.state?.openTab);
      }
    }
  }, [location]);

  return (
    <div className="page-container ml-auto px-9 py-6 org-details-container">
      <div className="flex pb-4 back-btn-container items-center cursor-pointer">
        <img
          src={leftIcon}
          alt=""
          onClick={() =>
            user.role === "superAdmin"
              ? history.push("/organizations")
              : history.push("/")
          }
        />
        <span
          className="ml-3 text-xl home-text"
          onClick={() =>
            user.role === "superAdmin"
              ? history.push("/organizations")
              : history.push("/")
          }>
          Home
        </span>
      </div>
      <div className="flex flex-wrap">
        <div className="bg-white rounded-xl w-full tab-options-container">
          {user.role === "superAdmin" && (
            <ul
              className="border-2 flex flex-row flex-wrap list-none mb-0 mt-9 mx-9 p-0 rounded-xl tab-container"
              role="tablist">
              <li className="-mb-px last:mr-0 flex-auto text-center sub-tabs">
                <a
                  className={
                    "text-xs px-5 py-3 rounded block leading-normal sub-tabs text-base" +
                    (openTab === 1
                      ? " selected-text font-black"
                      : " unselected-text font-bold")
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    setOpenTab(1);
                    setShowEditAccount(false);
                    setShowUserEdit(false);
                    setShowAddUser(false);
                    if (user.role === "orgAdmin") {
                      getOrganization();
                    }
                  }}
                  data-toggle="tab"
                  href="#link1"
                  role="tablist">
                  Account Details
                </a>
              </li>
              <li className="-mb-px last:mr-0 flex-auto text-center sub-tabs">
                <a
                  className={
                    "text-xs px-5 py-3 rounded block leading-normal sub-tabs text-base" +
                    (openTab === 2
                      ? " selected-text font-black"
                      : " unselected-text font-bold")
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    setOpenTab(2);
                    setShowAddUser(false);
                  }}
                  data-toggle="tab"
                  href="#link2"
                  role="tablist">
                  User Management
                </a>
              </li>
              <li className="-mb-px last:mr-0 flex-auto text-center sub-tabs">
                <a
                  className={
                    "text-xs px-5 py-3 rounded block leading-normal sub-tabs text-base" +
                    (openTab === 3
                      ? " selected-text font-black"
                      : " unselected-text font-bold")
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    addToast("Coming Soon", "", ToastTypes.info);
                    // setOpenTab(3);
                  }}
                  data-toggle="tab"
                  href="#link3"
                  role="tablist">
                  Settings
                </a>
              </li>
              <li className="-mb-px last:mr-0 flex-auto text-center sub-tabs">
                <a
                  className={
                    "text-xs px-5 py-3 rounded block leading-normal sub-tabs text-base" +
                    (openTab === 4
                      ? " selected-text font-black"
                      : " unselected-text font-bold ")
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    addToast("Coming Soon", "", ToastTypes.info);
                    // setOpenTab(4);
                  }}
                  data-toggle="tab"
                  href="#link4"
                  role="tablist">
                  Activity
                </a>
              </li>
            </ul>
          )}
          <div
            className={`break-words flex flex-col min-w-0 relative w-full ${
              user.role === "orgAdmin" ? "mt-9" : ""
            }`}>
            <div className="px-4 flex-auto">
              <div className="tab-content tab-space">
                <div
                  className={
                    openTab === 1
                      ? "block account-details-container"
                      : "hidden account-details-container"
                  }
                  id="link1">
                  <AccountDetail
                    user={user}
                    addToast={addToast}
                    showEditAccount={showEditAccount}
                    setShowEditAccount={setShowEditAccount}
                    org={orgData?.organization}
                  />
                </div>
                <div className={openTab === 2 ? "block" : "hidden"} id="link2">
                  <UserManagement
                    user={user}
                    addToast={addToast}
                    openTab={openTab}
                    showAddUser={showAddUser}
                    showUserEdit={showUserEdit}
                    setShowUserEdit={setShowUserEdit}
                    setShowAddUser={setShowAddUser}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.auth,
  orgData: state.orgData,
});

const OrgDetailsPage = withToast(
  connect(mapStateToProps)(OrgDetailsPageComponent)
);

export default OrgDetailsPage;
